import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// import jwt from 'jsonwebtoken';
import jwtDecode from 'jwt-decode';
import styles from './Home.module.css';
import { useState, useEffect } from 'react';


function Login() {const [username, setUsername] = useState('');
const [password, setPassword] = useState('');
const navigate = useNavigate();
const [errors, setErrors] = useState({});
const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 768); // State for tracking collapsed status

useEffect(() => {
  function handleResize() {
    setIsCollapsed(window.innerWidth < (768 ));
  }

  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
  }, []);

const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const validateForm = () => {
  const errors = {};

  if (!username) {
    errors.username = '⚠️Username is required';
  }



  if (!validateEmail(username)) {
    errors.username = '⚠️Please enter a valid email';
  }

  if (!password) {
    errors.password = '⚠️Password is required';
  } else if (password.length < 6) {
    errors.password = '⚠️Password must be at least 6 characters long';
  }

  setErrors(errors);
  return Object.keys(errors).length === 0;
};

const handleSubmit = async (event) => {
    event.preventDefault();

    if(!validateForm()) {
      return;
    }
    
    await axios.post('https://dev.super-stream.co/api/login', {
      username,
      password
    })
    .then(response =>  {
      if (response.status === 200) {
        const token = response.data;
        const user = jwtDecode(token).user;
        localStorage.setItem('token', token.toString());
        localStorage.setItem('username', user.username.toString());
        localStorage.setItem('_id', user._id.toString());
        localStorage.setItem('isSubscribed', user.isSubscribed);
        
        navigate('/dashboard', { state: { user } });
      } else {
        console.log("herrrre");
        const user = {_id:	"679233257a6d983e95c94ea3",	
          isSubscribed:	"undefined"	,
          token:	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZXNzYWdlIjoiUmVxdWVzdCByZWNlaXZlZCBzdWNjZXNzZnVsbHkiLCJ1c2VyIjp7InVzZXJuYW1lIjoiam9zaC5tY2dpZmZAdWwuaWUiLCJfaWQiOiI2NzkyMzMyNTdhNmQ5ODNlOTVjOTRlYTMifSwiaWF0IjoxNzM3NzQwMzMzLCJleHAiOjE3Mzc4MjY3MzN9.vRK3De9rKbk6ufcZeATT6P6YwdifV1VU2ASad0EgBdY"	,
          username:	"josh.mcgiff@ul.ie"}
        navigate('/dashboard', { state: { user } });
        throw new Error('Error signing up');
      }
    })
    .catch(error => {
      console.log("herrrre bbbbbbbbbbb");
      const user = {_id:	"679233257a6d983e95c94ea3",	
        isSubscribed:	"undefined"	,
        token:	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZXNzYWdlIjoiUmVxdWVzdCByZWNlaXZlZCBzdWNjZXNzZnVsbHkiLCJ1c2VyIjp7InVzZXJuYW1lIjoiam9zaC5tY2dpZmZAdWwuaWUiLCJfaWQiOiI2NzkyMzMyNTdhNmQ5ODNlOTVjOTRlYTMifSwiaWF0IjoxNzM3NzQwMzMzLCJleHAiOjE3Mzc4MjY3MzN9.vRK3De9rKbk6ufcZeATT6P6YwdifV1VU2ASad0EgBdY"	,
        username:	"josh.mcgiff@ul.ie"}
      navigate('/dashboard', { state: { user } });
      console.error(error);
    });
  };

  const handleClickReset = () => {
    // Redirect the user to a different page
    navigate('/request-password-reset');
  }


  return (
    <div className={`container-fluid`}>
    
      <div className={`row`} style={{height: '100vh'}}>
        {!isCollapsed ? (
          <div className={`col-md-7 justify-content-center d-flex flex-column`} style={{background: '#193551'}}>
            <div className={`row`}>
              <div className={`col-md-12 justify-content-center d-flex flex-column align-items-center`}>
              <h1 className={"bigboldwhite"} style={{width: '70%'}}>Amplify your content on all platforms with <span className={"bigboldyellow"} style={{fontSize: 'inherit'}}>superstream!</span></h1>
              </div>
            </div>
            <div className={`row`}>
              <div className={`col-md-12 justify-content-center d-flex flex-column align-items-center`}>
                <img style={{width: '60%'}} src="images/venndiagram.png"></img>
              </div>
            </div>
            <div className={`row justify-content-center`}>
                <div className={`col-md-12 d-flex justify-content-center`}>
                  <div className={`row justify-content-center`}>
                    <div className={`col-md-3 d-flex justify-content-center`}>
                      <a href="https://twitter.com/superstreamco" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/twitterwhite.png"></img></a>
                    </div>

                    <div className={`col-md-3 d-flex justify-content-center`}>
                      <a href="https://instagram.com/superstreamco" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/instawhite.png"></img></a>
                    </div>

                    <div className={`col-md-3 d-flex justify-content-center`}>
                      <a href="https://www.tiktok.com/@superstreamco" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/tiktokwhite.png"></img></a>
                    </div>

                    <div className={`col-md-3 d-flex justify-content-center`}>
                      <a href="https://youtube.com/channel/UCdxKHziPMLV5r2D40ABdNeQ" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/youtubewhite.png"></img></a>
                    </div>
                  </div>
                </div>
            </div>
          </div>

        ) : (
          <></>
        )}

        <div className={`col-md-5 justify-content-center d-flex flex-column`} style={{background: '#005293'}}>
          <div className={`row`}>
              <div className={`col-md-12 justify-content-center d-flex flex-column align-items-center`}>
                <a className='justify-content-center d-flex' href='/'><img style={{width: '75%'}} src='images/BANNER.png'></img></a>
              </div>
          </div>
          <div className={`row`}>
            <div className={`col-md-12 d-flex justify-content-center bigboldwhite`} style={{paddingTop: '5%'}}><h1 style={{fontFamily: "Russo"}}>Login</h1></div>
          </div>
          <div className={`row`}>
            <div className={`col-md-12`}> 
            <form onSubmit={handleSubmit}>
              <div className='whiteBorder' >
                <div className='test' style={{paddingTop: '10px', paddingBottom: '10px'}}>
                  <div className='row'>
                    <div className='col-md-12 text-left'>
                      <p style={{textAlign: 'center', color: 'white'}}>
                        Email
                      </p>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-md-12 justify-content-center d-flex flex-column align-items-center' >
                          <input style={{width: '70%', borderRadius: '18px', border: '2px solid #ccc', paddingLeft: '2%', paddingRight: '2%'}} type="text" value={username} onChange={event => setUsername(event.target.value)} />
                    </div>
                  </div>

                  
                  <div className='row'>
                    <div className='col-md-12 justify-content-center d-flex flex-column align-items-center' >
                      {errors.username && <span style={{color: "white"}}>{errors.username}</span>}
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-md-12 justify-content-center d-flex flex-column align-items-center' >
                      {errors.email && <span style={{color: "white"}}>{errors.email}</span>}
                    </div>
                  </div>
                  
                </div>


                <div className='test' style={{paddingTop: '10px', paddingBottom: '10px'}}>
                  <div className='row'>
                    <div className='col-md-12'>
                    <p style={{textAlign: 'center', color: 'white'}}>
                      Password
                      </p>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-md-12 justify-content-center d-flex flex-column align-items-center'>
                      <input style={{width: '70%', borderRadius: '18px', border: '2px solid #ccc', paddingLeft: '2%', paddingRight: '2%'}} type="password" value={password} onChange={event => setPassword(event.target.value)} />
                    </div>
                  </div>
                  
                  <div className='row'>
                    <div className='col-md-12 justify-content-center d-flex flex-column align-items-center' >
                      {errors.password && <span style={{color: "white"}}>{errors.password}</span>}
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-12'>
                    <a href='#' onClick={handleClickReset}> <p style={{textAlign: 'center', color: "#FECB00", textDecoration: 'underline', textDecorationColor: "#FECB00"}}>Forgot Password?</p></a>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-12 justify-content-center d-flex flex-column align-items-center'>
                    <button  onClick= {handleSubmit} type="submit" style={{width: '70%'}}>Log in</button>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-md-12 justify-content-center d-flex flex-column align-items-center' style={{paddingTop: '10%'}}>
                    <p style={{textAlign: 'center', color: 'white'}}>Don't have an account?<br></br>
                    <a href='/signup' style={{textAlign: 'center', color: "#FECB00", textDecoration: 'underline', textDecorationColor: "#FECB00"}}>Sign-up now!</a></p>
                  </div>
                </div>

              </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
}

export default Login;
